import { Button } from '@mui/material'
import { AnimatePresence } from 'framer-motion'
import { useDispatch } from 'react-redux'
import CreativeBackgroundImage from 'images/creative-background.svg'
import DoneImage from 'images/done-filled.svg'
import * as TemplateActions from '../../../template.actions'
import * as css from '../styles'

export const ToggleAi = ({ isEnabled }: { isEnabled: boolean }) => {
  const dispatch = useDispatch()

  function toggleAiClassification() {
    dispatch(TemplateActions.toggleCreativeClassification(!isEnabled))
  }

  return (
    <css.ToggleAiContainer>
      {isEnabled ? (
        <AnimatePresence>
          <div style={{ position: 'relative' }}>
            <DoneImage
              style={{
                position: 'absolute',
                top: 0,
                zIndex: 1,
                left: '50%',
                transform: 'translateX(-50%)',
              }}
            />
            <CreativeBackgroundImage style={{ opacity: 0.6 }} />
          </div>
        </AnimatePresence>
      ) : (
        <CreativeBackgroundImage />
      )}
      <Button
        variant="outlined"
        onClick={() => {
          toggleAiClassification()
        }}
        sx={css.toggleAiButtonSxProps(isEnabled)}
      >
        {isEnabled ? 'Remove Classifications' : 'Enable Now'}
      </Button>
    </css.ToggleAiContainer>
  )
}
